const translations = {
  pt: {
    subheadline: "Founder & CEO @ Guebly",
    miniIntro: "Construo produtos digitais e marcas que viram negócio.",
    linksTitle: "Links",
    linksText: "Escolhe e entra. Direto ao ponto.",
    holdingMain: "Guebly Holding",
    holdingSub: "Ecossistema, produtos e visão",
    personalMain: "Site pessoal",
    personalSub: "deGabriel · Inovação empresarial",
    emailMain: "Email profissional",
    emailSub: "gabriel@guebly.com.br",
    githubMain: "GitHub",
    githubSub: "Código e repositórios",
    linkedinMain: "LinkedIn",
    linkedinSub: "Negócios e posicionamento",
    instagramMain: "Instagram",
    instagramSub: "Bastidores e construção",
    companiesTitle: "Empresas do grupo Guebly",
    companiesText: "Marcas criadas e operadas dentro da Guebly.",
    studioDesc: "Branding • Design • Websites",
    contabilDesc: "Contabilidade + automação",
    payDesc: "Checkout • PIX • Cartão",
    gamesDesc: "Games e entretenimento digital",
    toastTitle: "Bem-vindo 👋",
    toastText: "Escolhe um link e entra direto.",
    toastCopiedTitle: "Link copiado ✓",
    toastCopiedText: "Cola onde quiser.",
    share: "Compartilhar",
    ariaThemeLight: "Mudar para modo claro",
    ariaThemeDark: "Mudar para modo escuro",
    ariaClose: "Fechar notificação",
    ariaShare: "Compartilhar página",
    ariaHolding: "Guebly Holding — Ecossistema, produtos e visão",
    ariaPersonal: "deGabriel — Marca pessoal e presença profissional",
    ariaEmail: "Email profissional — gabriel@guebly.com.br",
    ariaGithub: "GitHub — Código e repositórios",
    ariaLinkedin: "LinkedIn — Negócios e posicionamento",
    ariaInstagram: "Instagram — Bastidores e construção",
    whatsappMain: "WhatsApp",
    whatsappSub: "Fala direto com a Guebly",
    ariaWhatsapp: "WhatsApp — Fala direto com a Guebly",
    ariaStudio: "Guebly Studio — Branding, Design e Websites",
    ariaContabil: "Guebly Contábil — Contabilidade + automação",
    ariaPay: "Guebly Pay — Checkout, PIX e Cartão",
    ariaGames: "Guebly Games — Games e entretenimento digital",
    footer: "@degabrielofi",
  },
  en: {
    subheadline: "Founder & CEO @ Guebly",
    miniIntro: "I build digital products and brands that become businesses.",
    linksTitle: "Links",
    linksText: "Pick one and go. Straight to the point.",
    holdingMain: "Guebly Holding",
    holdingSub: "Ecosystem, products and vision",
    personalMain: "Personal website",
    personalSub: "deGabriel · Business innovation",
    emailMain: "Professional email",
    emailSub: "gabriel@guebly.com.br",
    githubMain: "GitHub",
    githubSub: "Code and repositories",
    linkedinMain: "LinkedIn",
    linkedinSub: "Business and positioning",
    instagramMain: "Instagram",
    instagramSub: "Behind the scenes",
    companiesTitle: "Guebly Group companies",
    companiesText: "Brands built and operated within Guebly.",
    studioDesc: "Branding • Design • Websites",
    contabilDesc: "Accounting + automation",
    payDesc: "Checkout • PIX • Card",
    gamesDesc: "Games and digital entertainment",
    toastTitle: "Welcome 👋",
    toastText: "Pick a link and dive in.",
    toastCopiedTitle: "Link copied ✓",
    toastCopiedText: "Paste it wherever you want.",
    share: "Share",
    ariaThemeLight: "Switch to light mode",
    ariaThemeDark: "Switch to dark mode",
    ariaClose: "Close notification",
    ariaShare: "Share page",
    ariaHolding: "Guebly Holding — Ecosystem, products and vision",
    ariaPersonal: "deGabriel — Personal brand and professional presence",
    ariaEmail: "Professional email — contato@degabrielofi.com.br",
    ariaGithub: "GitHub — Code and repositories",
    ariaLinkedin: "LinkedIn — Business and positioning",
    ariaInstagram: "Instagram — Behind the scenes",
    whatsappMain: "WhatsApp",
    whatsappSub: "Talk directly with Guebly",
    ariaWhatsapp: "WhatsApp — Talk directly with Guebly",
    ariaStudio: "Guebly Studio — Branding, Design and Websites",
    ariaContabil: "Guebly Contábil — Accounting + automation",
    ariaPay: "Guebly Pay — Checkout, PIX and Card",
    ariaGames: "Guebly Games — Games and digital entertainment",
    footer: "@degabrielofi",
  },
  es: {
    subheadline: "Founder & CEO @ Guebly",
    miniIntro: "Construyo productos digitales y marcas que se convierten en negocios.",
    linksTitle: "Links",
    linksText: "Elige y entra. Directo al grano.",
    holdingMain: "Guebly Holding",
    holdingSub: "Ecosistema, productos y visión",
    personalMain: "Sitio personal",
    personalSub: "deGabriel · Innovación empresarial",
    emailMain: "Email profesional",
    emailSub: "gabriel@guebly.com.br",
    githubMain: "GitHub",
    githubSub: "Código y repositorios",
    linkedinMain: "LinkedIn",
    linkedinSub: "Negocios y posicionamiento",
    instagramMain: "Instagram",
    instagramSub: "Entre bastidores",
    companiesTitle: "Empresas del grupo Guebly",
    companiesText: "Marcas creadas y operadas dentro de Guebly.",
    studioDesc: "Branding • Diseño • Sitios web",
    contabilDesc: "Contabilidad + automatización",
    payDesc: "Checkout • PIX • Tarjeta",
    gamesDesc: "Juegos y entretenimiento digital",
    toastTitle: "Bienvenido 👋",
    toastText: "Elige un link y entra directamente.",
    toastCopiedTitle: "Link copiado ✓",
    toastCopiedText: "Pégalo donde quieras.",
    share: "Compartir",
    ariaThemeLight: "Cambiar a modo claro",
    ariaThemeDark: "Cambiar a modo oscuro",
    ariaClose: "Cerrar notificación",
    ariaShare: "Compartir página",
    ariaHolding: "Guebly Holding — Ecosistema, productos y visión",
    ariaPersonal: "deGabriel — Marca personal y presencia profesional",
    ariaEmail: "Email profesional — contato@degabrielofi.com.br",
    ariaGithub: "GitHub — Código y repositorios",
    ariaLinkedin: "LinkedIn — Negocios y posicionamiento",
    ariaInstagram: "Instagram — Entre bastidores",
    whatsappMain: "WhatsApp",
    whatsappSub: "Habla directamente con Guebly",
    ariaWhatsapp: "WhatsApp — Habla directamente con Guebly",
    ariaStudio: "Guebly Studio — Branding, Diseño y Sitios web",
    ariaContabil: "Guebly Contábil — Contabilidad + automatización",
    ariaPay: "Guebly Pay — Checkout, PIX y Tarjeta",
    ariaGames: "Guebly Games — Juegos y entretenimiento digital",
    footer: "@degabrielofi",
  },
  it: {
    subheadline: "Founder & CEO @ Guebly",
    miniIntro: "Creo prodotti digitali e brand che diventano business.",
    linksTitle: "Link",
    linksText: "Scegli ed entra. Dritto al punto.",
    holdingMain: "Guebly Holding",
    holdingSub: "Ecosistema, prodotti e visione",
    personalMain: "Sito personale",
    personalSub: "deGabriel · Innovazione aziendale",
    emailMain: "Email professionale",
    emailSub: "gabriel@guebly.com.br",
    githubMain: "GitHub",
    githubSub: "Codice e repository",
    linkedinMain: "LinkedIn",
    linkedinSub: "Business e posizionamento",
    instagramMain: "Instagram",
    instagramSub: "Dietro le quinte",
    companiesTitle: "Aziende del gruppo Guebly",
    companiesText: "Brand creati e gestiti all'interno di Guebly.",
    studioDesc: "Branding • Design • Siti web",
    contabilDesc: "Contabilità + automazione",
    payDesc: "Checkout • PIX • Carta",
    gamesDesc: "Giochi e intrattenimento digitale",
    toastTitle: "Benvenuto 👋",
    toastText: "Scegli un link ed entra direttamente.",
    toastCopiedTitle: "Link copiato ✓",
    toastCopiedText: "Incollalo dove vuoi.",
    share: "Condividi",
    ariaThemeLight: "Passa alla modalità chiara",
    ariaThemeDark: "Passa alla modalità scura",
    ariaClose: "Chiudi notifica",
    ariaShare: "Condividi pagina",
    ariaHolding: "Guebly Holding — Ecosistema, prodotti e visione",
    ariaPersonal: "deGabriel — Brand personale e presenza professionale",
    ariaEmail: "Email professionale — gabriel@guebly.com.br",
    ariaGithub: "GitHub — Codice e repository",
    ariaLinkedin: "LinkedIn — Business e posizionamento",
    ariaInstagram: "Instagram — Dietro le quinte",
    whatsappMain: "WhatsApp",
    whatsappSub: "Parla direttamente con Guebly",
    ariaWhatsapp: "WhatsApp — Parla direttamente con Guebly",
    ariaStudio: "Guebly Studio — Branding, Design e Siti web",
    ariaContabil: "Guebly Contábil — Contabilità + automazione",
    ariaPay: "Guebly Pay — Checkout, PIX e Carta",
    ariaGames: "Guebly Games — Giochi e intrattenimento digitale",
    footer: "@degabrielofi",
  },
};

export default translations;
